// components/common/MultiSelectAutocomplete.tsx

import React from "react";
import {
  Autocomplete,
  Box,
  Checkbox,
  ListItemText,
  TextField,
  Tooltip,
} from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import "./autocomplete.scss"
import { MultiSelectAutocompleteProps,OptionType } from "./autocomplete-props";
import Popper from '@mui/material/Popper';
import { styled } from '@mui/material/styles';

const CustomPopper = styled(Popper)({
  zIndex: '5 !important',
  '& .MuiAutocomplete-listbox': {
    maxHeight: '170px',
    overflowY: 'auto',
    padding: 0,
    margin: 0,
  },
  '& .MuiPaper-root': {
    padding: 0,
    overflow: 'hidden', 
  }
});

const MultiSelectAutocomplete: React.FC<MultiSelectAutocompleteProps> = ({
  options,
  selectedValues,
  onChange,
  placeholder = "Select",
}) => {
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const selectedOptions = options.filter((option) =>
    selectedValues.includes(option.value)
  );

  const handleChange = (_event: any, selected: OptionType[]) => {
    const selectedIds = selected.map((opt) => opt.value);
    onChange(selectedIds);
  };

  return (
    <div className="autocomplete-multi-select-input-component">
      <div>
      <Autocomplete
      disablePortal
      multiple
      options={options}
      disableCloseOnSelect
      popupIcon={<KeyboardArrowDownIcon />}
      value={selectedOptions}
      onChange={handleChange}
      getOptionLabel={(option) => option.label}
      PopperComponent={CustomPopper}
      renderTags={() => null}
      componentsProps={{
        paper: {
          sx: {
            padding: '0px !important',
           // maxHeight:"170px"
          }
        }
      }}
      renderOption={(props, option, { selected }) => (
        <li {...props} style={{ padding: 0 }}>
    <Box
      sx={{
        width: "100%",
        borderRadius: "8px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: "35px",
        px: 2,
        py: 1,
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          backgroundColor: "#8879501a",
          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
        }
      }}
    >
          <ListItemText primary={option.label} />
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            checked={selected}
 
            style={{ marginLeft: 8 }}
          />
          </Box>
        </li>
      )}
      renderInput={(params) => {
        const selectedLabels = selectedOptions.map((opt) => opt.label).join(", ");
        const isInputActive = params.inputProps?.value || selectedOptions.length > 0;
        return (
          <TextField
            {...params}
            placeholder={selectedOptions.length === 0 ? placeholder : ""}
            InputProps={{
              ...params.InputProps,
              style: {
                display: 'flex',
                alignItems: 'center',
              },
              startAdornment: (
                <Tooltip title={selectedLabels} placement="top"
                componentsProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: '#f6f6f6', 
                      color: '#000',
                      fontWeight:400,        

                    },
                  },
                }}
                >
                  <div
                    style={{
                      maxWidth: "calc(100% - 30px)", // Leave space for icon
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      color: "#000",
                      fontSize: "14px",
                    }}
                  >
                    {selectedLabels.length > 30
                      ? selectedLabels.slice(0, 30) + "..."
                      : selectedLabels}
                  </div>
                </Tooltip>
              )
            }}
            inputProps={{
              ...params.inputProps,
              style: {
                paddingLeft: selectedOptions.length > 0 ? 4 : undefined,
              },
            }}
          />
        );
      }}
      
      
    />
      </div>
    </div>
  );
};

export default MultiSelectAutocomplete;
